import React from 'react';
import GridFilter from '../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../Base/Enums/GridFilterItemType.enum';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import useFilters from '../../../Base/Hooks/useFilters';

export interface WorkplaceCalendarWithFilterValues {
	doctorIds?: string[];
}

interface Props {
	onFilter: (values: WorkplaceCalendarWithFilterValues) => void;
	defaultValues?: WorkplaceCalendarWithFilterValues;
}

const WorkplaceCalendarFilter: React.FC<Props> = ({
	onFilter,
	defaultValues,
}) => {
	const { handleMultiSelectValue } = useFilters();
	const onFilterData = (values: any) => {
		const filter: WorkplaceCalendarWithFilterValues = {
			doctorIds: handleMultiSelectValue(values?.doctorIds),
		};
		onFilter(filter);
	};

	const prepareDefaultValues = (values?: WorkplaceCalendarWithFilterValues) => {
		if (values) {
			return {
				doctorIds: values?.doctorIds?.map(item => {
					return { value: item };
				}),
			};
		}
		return undefined;
	};

	return (
		<GridFilter
			onChange={onFilterData}
			defaultValues={prepareDefaultValues(defaultValues)}>
			<GridFilterItem
				type={GridFilterItemType.DOCTOR_IDS}
				width={430}
				customLabel='base.pickWorker'
				customPlaceholder='base.shared.pick'
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default WorkplaceCalendarFilter;
